/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';

const API = process.env.REACT_APP_API_URL || 'https://lexback-production.up.railway.app';

export default function ResetPassword() {
  const [searchParams]          = useSearchParams();
  const navigate                 = useNavigate();
  const token                    = searchParams.get('token');
  const [password, setPassword]  = useState('');
  const [confirm, setConfirm]    = useState('');
  const [loading, setLoading]    = useState(false);
  const [validating, setValidating] = useState(true);
  const [tokenValid, setTokenValid] = useState(false);
  const [done, setDone]          = useState(false);
  const [error, setError]        = useState('');

  useEffect(() => {
    if (!token) { setValidating(false); return; }
    fetch(`${API}/api/auth/verify-reset-token/${token}`)
      .then(r => { setTokenValid(r.ok); setValidating(false); })
      .catch(() => { setTokenValid(false); setValidating(false); });
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { setError('Les mots de passe ne correspondent pas'); return; }
    if (password.length < 8)  { setError('Minimum 8 caractères'); return; }
    setLoading(true); setError('');
    try {
      const res = await fetch(`${API}/api/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password }),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.detail || 'Erreur'); return; }
      setDone(true);
      setTimeout(() => navigate('/login'), 3000);
    } catch { setError('Erreur réseau.'); }
    finally { setLoading(false); }
  };

  const box = { background:'#fff', border:'0.5px solid rgba(0,0,0,0.07)', borderRadius:'14px', padding:'2.5rem', width:'100%', maxWidth:'420px', boxShadow:'0 1px 3px rgba(0,0,0,0.05)' };
  const wrap = { minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'#F5F3EE', padding:'2rem' };

  if (validating) return (
    <div style={wrap}><div style={box}><div style={{ textAlign:'center', color:'rgba(26,25,22,0.4)', fontSize:'13px' }}>Vérification du lien…</div></div></div>
  );

  if (!token || !tokenValid) return (
    <div style={wrap}>
      <div style={box}>
        <div style={{ fontFamily:'Syne, sans-serif', fontSize:'20px', fontWeight:700, color:'#B8860B', marginBottom:'16px' }}>Lexback</div>
        <div style={{ fontFamily:'Syne, sans-serif', fontSize:'16px', fontWeight:600, color:'#B03020', marginBottom:'10px' }}>Lien invalide ou expiré</div>
        <div style={{ fontSize:'13px', color:'rgba(26,25,22,0.5)', lineHeight:1.6, marginBottom:'24px' }}>
          Ce lien de réinitialisation est invalide ou a expiré (durée de validité : 1 heure).<br />Demandez un nouveau lien.
        </div>
        <Link to="/forgot-password" style={{ textDecoration:'none' }}>
          <button style={{ width:'100%', background:'#B8860B', color:'#fff', border:'none', padding:'10px', borderRadius:'8px', fontSize:'13px', fontWeight:500, cursor:'pointer', fontFamily:'DM Sans, sans-serif' }}>
            Demander un nouveau lien →
          </button>
        </Link>
      </div>
    </div>
  );

  if (done) return (
    <div style={wrap}>
      <div style={box}>
        <div style={{ fontFamily:'Syne, sans-serif', fontSize:'20px', fontWeight:700, color:'#B8860B', marginBottom:'16px' }}>Lexback</div>
        <div style={{ fontFamily:'Syne, sans-serif', fontSize:'16px', fontWeight:600, color:'#1A7A4A', marginBottom:'10px' }}>Mot de passe mis à jour ✓</div>
        <div style={{ fontSize:'13px', color:'rgba(26,25,22,0.5)', lineHeight:1.6 }}>
          Votre mot de passe a été réinitialisé avec succès.<br />Redirection vers la connexion…
        </div>
      </div>
    </div>
  );

  return (
    <div style={wrap}>
      <div style={box}>
        <div style={{ fontFamily:'Syne, sans-serif', fontSize:'20px', fontWeight:700, color:'#B8860B', marginBottom:'4px' }}>Lexback</div>
        <form onSubmit={handleSubmit}>
          <div style={{ fontFamily:'Syne, sans-serif', fontSize:'16px', fontWeight:600, color:'#1A1916', marginBottom:'6px' }}>Nouveau mot de passe</div>
          <div style={{ fontSize:'13px', color:'rgba(26,25,22,0.45)', marginBottom:'24px' }}>Choisissez un mot de passe sécurisé (min. 8 caractères).</div>

          {error && (
            <div style={{ background:'rgba(176,48,32,0.08)', border:'0.5px solid rgba(176,48,32,0.2)', borderRadius:'7px', padding:'10px 12px', fontSize:'12px', color:'#B03020', marginBottom:'16px' }}>
              {error}
            </div>
          )}

          {[
            { label:'Nouveau mot de passe', val:password, set:setPassword, id:'pwd' },
            { label:'Confirmer le mot de passe', val:confirm, set:setConfirm, id:'cpwd' },
          ].map(f => (
            <div key={f.id} style={{ marginBottom:'14px' }}>
              <div style={{ fontSize:'10px', textTransform:'uppercase', letterSpacing:'0.07em', color:'rgba(26,25,22,0.35)', marginBottom:'6px' }}>{f.label}</div>
              <input
                type="password" value={f.val} onChange={e => f.set(e.target.value)} required minLength={8}
                style={{ width:'100%', padding:'10px 12px', background:'#F0EDE5', border:'0.5px solid rgba(0,0,0,0.1)', borderRadius:'8px', fontSize:'13px', color:'#1A1916', outline:'none', fontFamily:'DM Sans, sans-serif', boxSizing:'border-box' }}
              />
            </div>
          ))}

          <button type="submit" disabled={loading||!password||!confirm} style={{ width:'100%', background:'#B8860B', color:'#fff', border:'none', padding:'10px', borderRadius:'8px', fontSize:'13px', fontWeight:500, cursor:loading?'not-allowed':'pointer', opacity:loading?0.7:1, fontFamily:'DM Sans, sans-serif', marginTop:'4px' }}>
            {loading ? 'Mise à jour…' : 'Enregistrer le nouveau mot de passe →'}
          </button>
        </form>
      </div>
    </div>
  );
}
